module.exports = __webpack_public_path__ + "img/alert.9b26c4cb.svg";